'use strict';

angular.module('app').directive('circleProgress', function (gettextCatalog) {
  return {
    restrict: 'E',
    scope: {
      total: '=',
      currentNumber: '=',
      size: '=',
      rotate: '=',
      prefix: '@',
    },
    link: function (scope, element) {
      function toRadians(deg) {
        return deg * Math.PI / 180;
      }

      function drawPieceCircle(ctx, radius, color, lineWidth, percent) {
        ctx.moveTo(0, 0);
        ctx.arc(0, 0, radius + (lineWidth / 2), 0, toRadians(percent), false);
        ctx.fillStyle = color;
        ctx.lineTo(0, 0);
        ctx.closePath();
        ctx.fill();
      }

      function drawCircle(ctx, color, lineWidth, radius) {
        // percent = Math.min(Math.max(0, percent || 1), 1);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, 360, false);
        ctx.strokeStyle = color;
        ctx.fillStyle = '#fff';
        ctx.lineCap = 'round'; // butt, round or square
        ctx.lineWidth = lineWidth;

        ctx.fill();
        ctx.stroke();
        ctx.closePath();
      }

      scope.$watch('currentNumber', function (newVal) {
        if (_.isNumber(newVal)) {
          var el = angular.element(element),
            options = {
              percent: scope.currentNumber / scope.total,
              size: 220,
              lineWidth: 50,
              rotate: scope.rotate || 0,
              prefix: scope.prefix || '',
            },
            canvas = document.createElement('canvas'),
            span = document.createElement('span');
          span.textContent = gettextCatalog.getString('{{step}} of {{totalSteps}}', { step: scope.currentNumber, totalSteps: scope.total});

          if (typeof (window.G_vmlCanvasManager) !== 'undefined') {
            window.G_vmlCanvasManager.initElement(canvas);
          }

          var ctx = canvas.getContext('2d');
          canvas.width = canvas.height = options.size;
          el[0].innerText = '';
          el.append(span);
          el.append(canvas);

          ctx.translate(options.size / 2, options.size / 2); // change center
          ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

          // imd = ctx.getImageData(0, 0, 240, 240);
          var radius = (options.size - options.lineWidth) / 2;

          drawCircle(ctx, '#efefef', options.lineWidth, radius);
          drawPieceCircle(ctx, radius, '#1e80bf', options.lineWidth, 360 * options.percent);
          drawCircle(ctx, '#fff', 0, radius - 15);
        }
      });
    },
  };
});
